<template>
  <div class="schema-titre-wrapper d-flex">
    <div class="d-flex scroll-action" v-if="shouldScroll">
      <div @click="scrollLeft()" class="d-flex justify-content-between align-items-center px-3"><font-awesome-icon :icon="['fas', 'chevron-left']" /></div>
      <div @click="scrollRight()" class="d-flex justify-content-between align-items-center px-3"><font-awesome-icon :icon="['fas', 'chevron-right']" /></div>
    </div>
    <ul ref="onglet" class="onglet-list">
      <li
        v-for="schemaDetail in schemaDetails"
        :key="schemaDetail.id"
        class="d-flex align-items-center"
        :class="{'active-tab': schemaDetail.id === currentSchema()}"
        @click.prevent="handleClickOnglet(schemaDetail.id)"
      >
        <div
          :class="['title-cell', 'flex-grow-1']"
          :contenteditable="isEditable[schemaDetail.id]"
          @blur.stop="handleBlur"
          @keydown.enter="handleEnter($event)"
          :ref="'input' + schemaDetail.id"
        >
          {{ schemaDetail.nom }}
        </div>
        <span
          v-if="!isReadOnly"
          class="arrow"
          @click.prevent.stop="handleClick($event, schemaDetail)"
          ><font-awesome-icon :icon="['fas', 'angle-down']"
        /></span>
      </li>
    </ul>
    <template v-if="!isReadOnly">
      <div v-if="isLoadingSchema()" class="d-flex add-cntr justify-content-between align-items-center">
        <div class="add-button">
          <b-spinner small type="grow"></b-spinner>
        </div>
      </div>
      <div v-else class="d-flex add-cntr justify-content-between align-items-center">
        <div class="add-button" @click.prevent="createSchema">
          <font-awesome-icon :icon="['fas', 'plus']" />
        </div>
      </div>
    </template>
    <vue-simple-context-menu
      :elementId="'ongletSchemaContextualMenu'"
      :options="[{ name: 'Supprimer', action:'deleteSchema' }, { name: 'Renommer', action:'rename' }]"
      :ref="'vueSimpleContextMenu'"
      @option-clicked="optionClicked"
    >
    </vue-simple-context-menu>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {EventBus, events} from '../../eventBus'
export default {
  props: {
    schemaDetails: {
      type: Array
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    hideAll: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      isEditable: {},
      detailsOptionSelected: {},
      shouldSave: false,
      shouldScroll: false,
      documentWidth: 0,
      isScrollStart: true,
      isScrollEnd: false
      // activeTabId: this.schemaDetails[0] ? this.schemaDetails[0].id : 0
    }
  },
  watch: {
    schemaDetails (val) {
      this.$nextTick().then(_ => {
        this.shouldScroll = this.tabListWidth() >= this.visibleWidth
      })
    }
  },
  mounted () {
    this.documentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    EventBus.$on(events.HAS_MODIFICATION, this._handleMidificationCheck)
  },
  computed: {
    visibleWidth () {
      return this.documentWidth - (this.documentWidth / 3)
    }
  },
  beforeDestroy () {
    EventBus.$off(events.HAS_MODIFICATION, this._handleMidificationCheck)
  },
  methods: {
    ...mapGetters(['isLoadingSchema', 'currentSchema']),
    scrollLeft () {
      const currentScrollX = this.$refs['onglet'].scrollLeft
      const currentScrollY = this.$refs['onglet'].scrollTop
      this.$refs['onglet'].scrollTo(currentScrollX - 80, currentScrollY)
    },
    scrollRight () {
      const currentScrollX = this.$refs['onglet'].scrollLeft
      const currentScrollY = this.$refs['onglet'].scrollTop
      this.$refs['onglet'].scrollTo(currentScrollX + 80, currentScrollY)
    },
    tabListWidth () {
      if (this.$refs['onglet']) {
        return parseInt(this.$refs['onglet'].clientWidth)
      }
      return 0
    },
    _handleMidificationCheck (hasModification) {
      this.shouldSave = hasModification
    },
    createSchema () {
      this.$emit('addSchema')
    },
    // affichage contexte menu au click
    handleClick (event, item) {
      this.$refs.vueSimpleContextMenu.showMenu(event, item)
    },
    optionClicked (event) {
      const menuName = event.option.name
      const menuAction = event.option.action
      let id = event.item.id
      this.detailsOptionSelected = event.item

      switch (menuName) {
        case 'Renommer':
          this.$set(this.isEditable, id, true)
          setTimeout(() => {
            this.$refs['input' + id][0].focus()
          })
          return
        case 'Supprimer':
          this.$emit(menuAction, id)
      }
    },
    handleBlur (event) {
      this.isEditable = {}
      if (event.target.innerText !== this.detailsOptionSelected.nom) {
        this.$emit('renameSchema', {schemaId: this.detailsOptionSelected.id, nom: event.target.innerText})
      }
    },
    async handleClickOnglet (id) {
      if (this.shouldSave) {
        const answer = await this.$bvModal.msgBoxConfirm(`Voulez-vous sauvegarder vos modifications ?`, {
          modalClass: 'base-modal',
          title: 'Sauvegarde',
          buttonSize: 'sm',
          headerClass: 'bg-primary',
          okVariant: 'outline-primary',
          okTitle: 'Sauvegarder',
          cancelVariant: 'outline-danger',
          cancelTitle: 'Quitter sans sauvegarder',
          footerClass: 'p-2',
          hideHeaderClose: false
        })
        if (answer) {
          EventBus.$emit(events.SAVE_CONFIRM, 'SF', () => this.$emit('tabChange', id))
          this.$emit('tabChange', id)
        } else {
          this.$emit('tabChange', id)
        }
      } else {
        this.$emit('tabChange', id)
      }
      this.activeTabId = id
      this.shouldSave = false
    },
    handleEnter (event) {
      event.target.blur()
      return false
    }

  }
}
</script>
<style lang="scss">
.schema-titre-wrapper {
  background-color: #f1f3f4;
  height: 38px;
  border-top: 1px solid #e5e5e5;
  .scroll-action {
    margin-bottom: 0;
    padding-left: 0;
    border-right: 1px solid #e5e5e5;
    -webkit-box-shadow: 10px 1px 7px -3px rgba(124, 124, 124, 0.4);
    -moz-box-shadow: 10px 1px 7px -3px rgba(124, 124, 124, 0.4);
    box-shadow: 10px 1px 7px -3px rgba(124, 124, 124, 0.4);
    div:first-child {
      border-right: 1px solid #e5e5e5;
    }
    div {
      cursor: pointer;
      color: #9395c1;
      &:hover {
        color: #2b3085;
      }
    }
  }

  .add-cntr {
    padding: 0 15px;
    -webkit-box-shadow: -9px 1px 7px -3px rgba(124, 124, 124, 0.4);
    -moz-box-shadow: -9px 1px 7px -3px rgba(124, 124, 124, 0.4);
    box-shadow: -9px 1px 7px -3px rgba(124, 124, 124, 0.4);
    .add-button {
      cursor: pointer;
      margin-bottom: 0;
    }
  }

  ul.onglet-list {
    list-style: none;
    display: flex;
    margin-bottom: 0;
    padding-left: 0;
    max-width: calc(100vw - (100vw / 3));
    overflow: hidden;
    li {
      padding: 0 15px;
      font-family: "Open Sans";
      color: rgba(0, 0, 0, 0.5);
      font-weight: 600;
      font-size: 12px;
      text-align: center;
      &:not(:last-child){
        min-width: 140px;
      }
      border-right: 1px solid #e5e5e5;
      cursor: default;
      .title-cell {
        padding-top: 10px;
        padding-bottom: 10px;
        text-transform: uppercase;
        white-space: nowrap;
      }
      .arrow {
        padding-left: 5px;
        cursor: pointer;
      }
      &.active-tab {
        box-shadow: 4px 0 15px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        color: #2b3085;
      }
    }
  }
.vue-simple-context-menu {
    border-radius: 0;
    &--active {
      top: -150% !important;
    }

    &__item {
      font-family: "Open Sans";
      font-size: 14px;
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 5px;
      padding-bottom: 5px;
      &:hover {
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/listOnglet.vue